<template lang="html">
  <div class="options" id="options" v-if="selectedCategorie != undefined">

    <div class="container">
      <div class="row">
        <div class="col-md-4">
          <h4><span class="mouseover">{{type.cMerknaam}} {{type.cModelnaam}}</span></h4>
          <h2>Opties en Accessoires</h2>
          <p >Hierbij een overzicht van leverbare opties en accessoires op deze {{type.cMerknaam}} {{type.cModelnaam}} {{type.cTypenaam_2}}.
          Hieronder kan er een keuze worden gemaakt om van categorie te wisselen om meerdere opties te bekijken.
          <span v-if="model.motor.length > 1">De {{type.cMerknaam}} {{type.cModelnaam}} heeft meerdere uitvoeringen waarbij opties en accessoires mogelijk kunnen verschillen van elkaar.</span>
          </p>
          <v-select
            class="style-chooser mt-3"
            v-model="selectedType"
            label="nTypeID"
            :getOptionLabel="getLabel"
            :options="model.motor"
          >
          <template v-slot:option="option">
            {{option.cTypenaam_1}} ({{Math.round(parseInt(option.Vermogen_elektromotor_kW)*1.36)}}pk)
          </template>
          </v-select>
          <v-select
            class="style-chooser mt-3"
            v-model="selectedCategorie"
            :options="options"
            label="Categorie"
          />
        </div>

        <div class="col-md-8 scrollbar" v-if="selectedCategorie != null" style="height: 500px;overflow-y: scroll;overflow: scroll; overflow-x:hidden;">

          <div class="row">
            <div class="col-md-6 masonry-item text-center" v-for="(option, index) in selectedCategorie.Opties" >
              <!-- block item markup -->
              <div v-if="option.bStandaard" class="checkmark--icon" v-b-tooltip.hover title="Standaard Optie">
                <i class="mdi mdi-check"></i>
              </div>
              <div style="display: flex; flex-direction: column-reverse; ">
                <p class="mb-0 mt-2">&euro; {{option.nPrijs.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}},-</p>
                <div>
                  <h4 class="px-3" style="word-wrap: break-word">{{option.cBeschrijving}}</h4>
                  {{option.cBijzonderheden}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import vSelect from 'vue-select';

export default {
  props:['typeID', 'model', 'type'],
  components: {
    vSelect
  },
  data(){
    return{
      options:null,
      selectedCategorie:null,
      selectedType:null
    }
  },
  watch: {
  	selectedType: function(newVal, oldVal) { // watch it
      this.getOptions(newVal);
    }
  },
  created(){
    this.selectedType = this.typeID;
    if(this.model.motor.length > 0){
      let findMotor = this.model.motor.find(motor=>{
        return motor.typeinformation[0].nTypeIDHist === this.typeID
      })
      if(findMotor !== undefined){
        this.selectedType = findMotor
      }
    }
    // this.getOptions(this.typeID);
  },
  methods:{
    getLabel(type){
      if(typeof type === 'object'){
        return `${type.cTypenaam_1} (${Math.round(parseInt(type.Vermogen_elektromotor_kW)*1.36)}pk)`
      }else{
        return ''
      }
    },
    searchModel(nameKey, myArray){
    for (var i=0; i < myArray.length; i++) {
        if (myArray[i].nTypeIDHist === nameKey) {
            return myArray[i];
            }
        }
    },
    getOptions(typeID){
      // this.selectedType = typeID;
      if(typeof typeID === 'object'){
        this.$axios.get('/api-car/getOpties/cClient=30abad7b-0b3f-452d-ab65-20c7db9520e8;nTypeIDhist='+typeID.typeinformation[0].nTypeIDHist).then((response)=>{
        this.options = response.data.getOptiesResult;
        this.selectedCategorie = this.options[0]
      });
      }else{
        this.$axios.get('/api-car/getOpties/cClient=30abad7b-0b3f-452d-ab65-20c7db9520e8;nTypeIDhist='+typeID).then((response)=>{
        this.options = response.data.getOptiesResult;
        this.selectedCategorie = this.options[0]
      });
      }
    }
  }

}
</script>

<style lang="scss" scoped>
  // @import "../node_modules/vue-select/src/scss/vue-select.scss";

  .checkmark--icon{
    width: 24px;
    height: 24px;
    background-color: #2ecc71;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    top: 10px;
    right: 10px;
    color: white;
  }
.options{
  position: relative;
  padding-top:60px;

  .style-list{
    list-style-type:none;
    padding:0;

    position: relative;
    text-align: center;
    display: block;

    li{
      color: #666666;
      display: block;
      font-family: "Poppins",sans-serif;
      
      /* font-weight: 400; */
      font-weight: 600;
      /* letter-spacing: 1px; */
      margin-bottom: 15px;
      text-transform: capitalize;

      display: inline-block;
      padding: 15px;
      cursor: pointer;

      i{
        background: #2ecc71 none repeat scroll 0 0;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        color: #ffffff;
        float: left;
        font-size: 21px;
        height: 30px;
        line-height: 30px;
        margin-right: 15px;
        text-align: center;
        width: 30px;
        z-index: 1;
      }
    }

    span{
       display: table;
       padding-top: 3px;
     }
  }

  .masonry-item{
    color:#666;
    /*-webkit-box-shadow:0 0 10px 0 rgba(0, 0, 0, 0.1);*/
    /*box-shadow:0 0 10px 0 rgba(0, 0, 0, 0.1);*/
    padding: 20px;
    border-radius: 8px;
    /*background: #fff;*/
    background-color: lighten(#2ecc71, 45%);
    margin-bottom: 20px;

    p{
       font-size: 18px;
        font-weight: 600;
        color: #666;
    }
    h4{
      color:#2ecc71 !important;
    }
  }

  .left-bubble{
    position: absolute;
    top: 100px;

    height: 200px * 2;
    width: 200px;
    border-bottom-right-radius: 200px * 2;
    border-top-right-radius: 200px * 2;
    background: #2ecc71;
     display: inline-block;
     box-shadow: 5px 1px 20px 0px #2ecc7180;
  }
  .right-bubble{
    position: absolute;
    top: 500px;
    right:0px;

    height: 160px * 2;
    width: 160px;
    border-bottom-left-radius: 160px * 2;
    border-top-left-radius: 160px * 2;
    background: #2ecc71;
     display: inline-block;
     box-shadow: -5px -1px 20px 0px #2ecc7180;
  }
.scrollbar::-webkit-scrollbar-track
{
	/*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1);*/
	background-color: #F5F5F5;
	border-radius: 10px;
}

.scrollbar::-webkit-scrollbar
{
	width: 10px;
	background-color: #FFF;
}

.scrollbar::-webkit-scrollbar-thumb
{
	border-radius: 10px;
	background-color: #2ecc71;
}
}
.vs__dropdown-toggle {
  border-radius: 30px;
}
  .vs__dropdown-menu {
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
  /*border: 1px solid #f1f1f1;*/
    border: none;
    box-shadow: 0 0 0 1px transparent, 0 0 0 1px #f1f1f1 !important;
  border-top: 0;
  box-shadow: none;
  }
  .vs__dropdown-option--highlight{
      background-color: #2ecc71 !important;
    }
  .style-chooser {
  &.vs--open {
    border-bottom-right-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
  }
  box-shadow: inherit;
  border: 1px solid #f1f1f1;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  border-radius: 30px;
  max-width: 225px;
.vs__open-indicator{
  display:none;
}
    .vs__dropdown-toggle{
  border: 0;
  padding-left: 20px;
  width: 100%;
  min-height: 60px;
  color: #232323;
  outline: none;
  font-weight: 400;
  font-family: 'Open Sans', sans-serif;
  
  font-size: 14px;
  z-index: 99999;
  background:#fff;
    }
  }
  .vs__clear{
    display: none;
  }
</style>
